/**
 * Session management utility.
 * Each browser tab gets a unique session ID stored in sessionStorage.
 * This ensures multiple simultaneous users don't conflict on the backend.
 */

const SESSION_KEY = 'nyafaz_session_id';

function generateUUID() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for older environments
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = generateUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function resetSession() {
  const id = generateUUID();
  sessionStorage.setItem(SESSION_KEY, id);
  return id;
}
